import store from "../store";

export default class Permissions {
    static checkModule(module_id) {
        if (!store.state?.modules?.modules) {
            return false;
        }
        return store.state.modules.modules[module_id];
    }
}
